import { Component } from "@angular/core";
import { NzModalService } from "ng-zorro-antd/modal";
import { NzMessageService } from "ng-zorro-antd/message";
import { EmbargoManagementPageDataService } from "../embargo-management-page-data.service";
import {
  VAIconRegistryService,
  eye,
  fileExcel,
  plus,
  sync,
  trash,
} from "@va/core-library/icons";

@Component({
  selector: "app-embargo-management-page",
  templateUrl: "./embargo-management-page.component.html",
  styleUrls: ["./embargo-management-page.component.scss"],
})
export class EmbargoManagementPageComponent {
  isEmbargoDefaultVisible = false;
  isEmbargoOverrideVisible = false;
  isEmbargoExportVisible = false;
  isDeleteModelVisible = false;
  defaultEmbargo = {
    model_data: 30,
    model_download: 0,
    research_download: 30,
  };
  editEmbargoOverrideData = {};
  deleteData = {};
  count = 0;
  embargoOverrideType = "";
  fetchGrid = false;
  buySideKeyword = "";
  brokerKeyword = "";
  sortBy = "";
  sortOrder = "";
  isFilterEnable = false;
  reloadTrigger = false;

  constructor(
    private modal: NzModalService,
    private dataService: EmbargoManagementPageDataService,
    private message: NzMessageService,
    private iconRegistry: VAIconRegistryService,
  ) {
    this.iconRegistry.registerIcons([trash, plus, eye, fileExcel, sync]);
  }

  showDefaultEmbargo() {
    this.isEmbargoDefaultVisible = true;
  }

  addEmbargoOverride() {
    this.editEmbargoOverrideData = {};
    this.embargoOverrideType = "Add";
    this.isEmbargoOverrideVisible = true;
  }

  viewDeleteModel() {
    this.isDeleteModelVisible = true;
  }

  closeModalEmbargoOverride($event) {
    this.isEmbargoOverrideVisible = $event;
  }

  showWarningModal(data) {
    this.editEmbargoOverrideData = {
      ...this.editEmbargoOverrideData,
      ...data,
    };
    this.isEmbargoOverrideVisible = false;
    this.warningModal();
  }

  warningModal() {
    this.modal.warning({
      nzTitle: "Save Changes to Overrides?",
      nzContent: "",
      nzOkText: "Submit",
      nzOkType: "primary",
      nzCancelText: "Cancel",
      nzOnOk: this.handleWarningSubmit.bind(this),
      nzOnCancel: this.handleWarningCancel.bind(this),
    });
  }

  handleWarningSubmit() {
    const obj = {
      type: 0,
      buysideId: this.editEmbargoOverrideData["buysideId"],
      brokerId: this.editEmbargoOverrideData["brokerId"],
      modelData: this.editEmbargoOverrideData["modelData"],
      modelDownload: this.editEmbargoOverrideData["modelDownload"],
      researchDownload: this.editEmbargoOverrideData["researchDownload"],
    };
    this.dataService
      .postEmbargoDetails(
        obj.type,
        obj.buysideId,
        obj.brokerId,
        obj.modelData,
        obj.modelDownload,
        obj.researchDownload,
      )
      .subscribe(
        (data) => {
          this.message.create("success", `${data}`);
          this.fetchGrid = !this.fetchGrid;
        },
        (err) => {
          this.message.create("error", `${err["error"]["errors"]}`);
          this.isEmbargoOverrideVisible = true;
        },
      );
  }

  handleWarningCancel() {
    this.isEmbargoOverrideVisible = true;
  }

  handleCancelForDefaultEmbargo() {
    this.isEmbargoDefaultVisible = false;
  }

  closeDeleteModal($event) {
    this.isDeleteModelVisible = $event;
  }

  setDefaultEmbargo(data): void {
    this.defaultEmbargo = data;
  }

  editEmbargoOverride(data): void {
    this.editEmbargoOverrideData = data;
    this.embargoOverrideType = "Edit";
    this.isEmbargoOverrideVisible = true;
  }

  triggerFetchGrid(): void {
    this.fetchGrid = !this.fetchGrid;
    this.isEmbargoOverrideVisible = false;
  }

  showExportEmbargo() {
    this.isEmbargoExportVisible = true;
  }

  closeModalEmbargoExport(status) {
    this.isEmbargoExportVisible = status;
  }

  changeKeyword($event) {
    this.buySideKeyword = $event.buyside;
    this.brokerKeyword = $event.broker;
  }

  changeSortObj($event) {
    this.sortBy = $event.sortBy;
    this.sortOrder = $event.sortOrder;
  }

  triggerFetchGridAfterDelete(): void {
    this.fetchGrid = !this.fetchGrid;
    this.isDeleteModelVisible = false;
  }

  countChanged(data): void {
    this.deleteData = data;
  }

  deleteCount($event: number) {
    this.count = $event;
  }

  onReloadTrigger(): void {
    this.reloadTrigger = !this.reloadTrigger;
  }
}
